import React, { useEffect, useState } from "react";
import { Button, ConfigProvider, Steps } from "antd";
import CustomReportTemplateList from "./CustomReportTemplateList";
import GenerateReport from "./GenerateReport";
import { useNavigate } from "react-router-dom";
import { useSearchQuery } from "../../utils/useSearchQuery";
const CustomReportTemplate = () => {
  const step = useSearchQuery("step");
  const navigate = useNavigate();

  const [selected, setSelected] = useState("");

  useEffect(() => {
    if (!selected) {
      navigate("/generate-report");
    }
  }, [selected]);

  return (
    <div className="px-md-3 mt-3 templatePage">
      <div className="border p-3">
        <div className="p-3 pt-0" style={{ width: 200 }}>
          <ConfigProvider theme={{ token: { colorPrimary: "#f05d43" } }}>
            <Steps
              size="default"
              direction="horizontal"
              responsive={false}
              current={Number(step)}
              items={[
                {
                  title: "",
                },
                {
                  title: "",
                },
              ]}
            />
          </ConfigProvider>
        </div>
        {parseInt(step) === 1 ? (
          <GenerateReport id={selected} />
        ) : (
          <CustomReportTemplateList {...{ selected, setSelected }} />
        )}
        {Number(step) !== 1 && (
          <div className="mt-3 d-flex justify-content-end">
            <Button type="primary" disabled={!selected} onClick={() => navigate("/generate-report?step=1")}>
              Next
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default CustomReportTemplate;
